export class StatusUtils {
  // User Status
  private static readonly USER_STATUS_DETAILS: {
    [key: number]: { class: string; text: string };
  } = {
    0: { class: 'badge-light-default', text: 'None' },
    1: { class: 'badge-light-primary', text: 'New Account' },
    2: { class: 'badge-light-success', text: 'Active' },
    3: { class: 'badge-light-danger', text: 'DeActive' },
    4: { class: 'badge-light-secondary', text: 'Blocked' },
    5: { class: 'badge-light-default', text: 'Deleted' },
  };

  private static readonly DEFAULT_USER_STATUS = {
    class: 'badge-light-dark',
    text: 'Unknown',
  };

  static getUserStatusClass(status: number): string {
    return (
      this.USER_STATUS_DETAILS[status]?.class || this.DEFAULT_USER_STATUS.class
    );
  }

  static getUserStatusText(status: number): string {
    return (
      this.USER_STATUS_DETAILS[status]?.text || this.DEFAULT_USER_STATUS.text
    );
  }
}
